import React from 'react';
import { avatarColor, avatarInitials, displayName } from './avatarUtils';

// Avatar de pessoa usado onde não há um avatar próprio da tela. Usa as mesmas
// regras de cor/iniciais do avatarUtils (inclusive homônimos), então a pessoa
// aparece igual no Kanban, na tabela, na atribuição e no editor da tarefa.
const SIZES = {
  xs: 'h-6 w-6 text-[10px]',
  sm: 'h-7 w-7 text-[10px]',
  md: 'h-8 w-8 text-xs',
  lg: 'h-9 w-9 text-sm',
};

export default function UserAvatar({ name, id, size = 'md', ring = false, className = '', ...rest }) {
  return (
    <span
      title={displayName(name, id)}
      className={`inline-flex shrink-0 items-center justify-center rounded-full font-bold text-white ${SIZES[size] || SIZES.md} ${avatarColor(name, id)} ${ring ? 'border-2 border-white' : ''} ${className}`}
      {...rest}
    >
      {avatarInitials(name, id)}
    </span>
  );
}